export function buildShareText({ shareMessage, defaultMessage, codeLine, linkLine }) {
  const message = String(shareMessage || '').trim() || String(defaultMessage || '').trim();
  const invitationDetails = [codeLine, linkLine].map((line) => String(line || '').trim()).filter(Boolean);

  return [message, invitationDetails.join('\n')].filter(Boolean).join('\n\n');
}
